import axios from "axios";

export const KIOSK_TOKEN_KEY = "mm_kiosk_token";
export const QR_TOKEN_KEY = "mm_qr_token";
export const kioskApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/kiosk`, timeout: 45000 });
// Kiosk mode switched off remotely (or token revoked) → drop the kiosk token so staff can sign in normally.
kioskApi.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && sessionStorage.getItem(QR_TOKEN_KEY)) {
    sessionStorage.removeItem(QR_TOKEN_KEY); // revoked/expired table session → rescan
    window.location.replace(sessionStorage.getItem("mm_qr_path") || "/");
    return Promise.reject(e);
  }
  if (e?.response?.status === 401 && localStorage.getItem(KIOSK_TOKEN_KEY)) {
    localStorage.removeItem(KIOSK_TOKEN_KEY);
    localStorage.setItem("mm_device_mode", "normal");
    if (!window.location.pathname.startsWith("/order")) window.location.replace("/login"); // never send a customer screen to staff login
  }
  return Promise.reject(e);
});
kioskApi.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem(QR_TOKEN_KEY) || localStorage.getItem(KIOSK_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const isKioskDevice = () => !!(sessionStorage.getItem(QR_TOKEN_KEY) || localStorage.getItem(KIOSK_TOKEN_KEY));
export const isTableQr = () => !!sessionStorage.getItem(QR_TOKEN_KEY);

export function deviceId() {
  let id = localStorage.getItem("mm_device_id");
  if (!id) {
    id = `dev-${(window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`)}`;
    localStorage.setItem("mm_device_id", id);
  }
  return id;
}

export const deviceMode = () => localStorage.getItem("mm_device_mode") || "";
export const setDeviceMode = (m) => localStorage.setItem("mm_device_mode", m);

export const VOICE_DOWN = "Voice ordering is temporarily unavailable. Please try again or use touch ordering.";
export const isServiceError = (e) => !e?.response || e.response.status >= 500 || e.code === "ECONNABORTED";

const turnError = (status, detail) => Object.assign(new Error(detail || "Voice ordering is temporarily unavailable"), { response: { status, data: { detail } } });


export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return (typeof d === "string" ? d : d?.operator_message || d?.message) || e?.message || "Something went wrong";
};

// Guided AI Cashier: answer the CURRENT question (seq). Quick steps answer at once; AI order interpretation
// returns a job id that is polled (no long-held request).
export async function runFlow(sid, body) {
  const start = (await kioskApi.post(`/sessions/${sid}/flow`, body, { timeout: 25000 })).data;
  if (!start.pending) return start;
  const t0 = Date.now();
  for (let n = 0; ; n += 1) {
    await new Promise((res) => { setTimeout(res, n < 16 ? 250 : 600); }); // quick polls first: most turns finish in 1-4 s
    if (Date.now() - t0 > 80000) throw turnError(504);
    let j;
    try { j = (await kioskApi.get(`/sessions/${sid}/turns/${start.turn_id}`, { timeout: 10000 })).data; }
    catch (e) { if (e?.response && e.response.status < 500) throw e; continue; }
    if (j.status === "done") return j;
    if (j.status === "error") throw turnError(j.code, j.detail);
  }
}
